import { createAsyncThunk } from '@reduxjs/toolkit'

import {
  createProductsRequest,
  deleteProductRequest,
  getProductsRequest,
  getTemporalToken,
  updateProductRequest,
} from '../../../../billing-api'
import { users } from '../../invoice-issuance/db/users'
import { registerLocalData } from '../fake-data'

const userName = JSON.parse(localStorage.getItem('userBilligData'))
const userLogin = { companyId: userName?.username }
const user = users.find((user) => user.companyId === userLogin.companyId)
const token = await getTemporalToken(user)

export const getProducts = createAsyncThunk(
  'appInvoice/getProducts',
  async () => {
    //const token = await getTemporalToken(user);
    const result = await getProductsRequest(token)

    registerLocalData(result)

    return result
  }
)

export const createProducts = createAsyncThunk(
  'appInvoice/createProducts',
  async (product) => {
    //const token = await getTemporalToken(user);
    const result = await createProductsRequest(product, token)

    return result
  }
)

export const updateProduct = createAsyncThunk(
  'appInvoice/updateProduct',
  async (product) => {
    //const token = await getTemporalToken(user);
    const result = await updateProductRequest(product, token)

    return result
  }
)

export const deleteProduct = createAsyncThunk(
  'appInvoice/deleteProduct',
  async (productId) => {
    //const token = await getTemporalToken(user);
    const result = await deleteProductRequest(productId, token)

    return result
  }
)
